import React from "react";
import captainBadge from "./../../graphics/elements/captainBadge.svg";
import brandedX from "./../../graphics/icons/x.svg";
import brandedV from "./../../graphics/icons/v.svg";
import { useHistory, useParams } from "react-router-dom";
import { captainAprovingPlayerToTeam } from '../../api/captainAprovingPlayerToTeam';
import { captainDisAprovePlayerToTeam } from '../../api/captainDisAprovePlayerToTeam';
import * as func from "../../utils/funcs";

import styles from "./ShowSinglePlayerRow.module.css";
import iconProfile from  "./../../graphics/elements/profile_photo.svg";

function ShowSinglePlayerRow(props) {
  const { playerObj, user, setPlayers } = props;
  const { leagueId, teamId } = useParams();
  const history = useHistory();

  const checkStatusForPlayerTitle = (status, checkedStatus) => {
    let res;
    status === checkedStatus
      ? (res = { display: "block" })
      : (res = { display: "none" });
    return res;
  };

  const checkStatusForVX = (playerStatus) => {
    let res;
    playerStatus === "awaiting_confirmation" &&
    func.validGroupMasters(user, teamId)
      ? (res = { display: "flex" })
      : (res = { display: "none" });
    return res;
  };

  const handleClick = () => {
    history.push(
      `/leagues/${leagueId}/teams/${teamId}/player/${playerObj.user_id}`
    );
  };

  const handleClickApproved = async (userId) => {
    // get response from the server about changing the status
    const res = await captainAprovingPlayerToTeam(leagueId, teamId, userId);

    // handle the state
    setPlayers((currentPlayers) =>
      currentPlayers.map((player) => {
        if (player.user_id === res.user_id) {
          return { ...player, status: "in_team" };
        } else {
          return player;
        }
      })
    );
  };

  const handleClickDecline = async (userId) => {
    const res = await captainDisAprovePlayerToTeam(
      leagueId,
      teamId,
      userId
    );

    // handle the state
    setPlayers((currentPlayers) =>
      currentPlayers.filter((player) => player.user_id !== res.user_id)
    );
  };

  return (
    <div className={styles.playerRow}>
      <img
        src={playerObj.profile_pic !== null
          ? playerObj.profile_pic
          : iconProfile
        }
        alt="תמונת שחקן"
        onClick={handleClick}
      />

      <div className={styles.row}>
        <div className={styles.nameAndTitle} onClick={handleClick}>
          <div>
            <h3>{playerObj.user.full_name}</h3>
            <span
              style={checkStatusForPlayerTitle(
                playerObj.status,
                "awaiting_confirmation"
              )}
            >
              מבקש להצטרף
            </span>
          </div>
          <img
            src={captainBadge}
            width="23px"
            alt="קפטן"
            style={checkStatusForPlayerTitle(playerObj.status, "captain")}
          />
        </div>

        <div className={styles.vx} style={checkStatusForVX(playerObj.status)}>
          <img
            src={brandedV}
            alt="צרף לקבוצה"
            onClick={() => handleClickApproved(playerObj.user.id)}
          />
          <img
            style={{ paddingRight: 10 }}
            src={brandedX}
            alt="סרב"
            onClick={() => handleClickDecline(playerObj.user.id)}
          />
        </div>
      </div>
    </div>
  );
}

export default ShowSinglePlayerRow;
